<div class="insights-panel">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
        <button
            *ngFor="let tab of tabs"
            class="tab-button"
            [class.active]="isActiveTab(tab.id)"
            (click)="setActiveTab(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tile-content">
        <!-- Current Schedule Tab -->
        <div *ngIf="isActiveTab('farm-overview')" class="tab-pane">
            <div class="insights-grid">
                <div class="left">
                    <div *ngIf="loading" class="loading">
                        Loading farm overview...
                    </div>
                    <div *ngIf="error && !loading" class="error">
                        {{ error }}
                    </div>
                    <ng-container *ngIf="!loading && !error">
                        <app-farm-overview
                            *ngFor="let f of farms"
                            [farm]="f.farm"
                            [alerts]="f.alerts"
                            [houses]="f.houses"
                        ></app-farm-overview>
                    </ng-container>
                </div>
                <div class="right">
                    <app-live-alerts></app-live-alerts>
                    <app-upcoming-tasks> </app-upcoming-tasks>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="isActiveTab('feed-inventory')" class="tab-pane">
            <div class="insights-parent"></div>
        </div>

        <div *ngIf="isActiveTab('analytics')" class="tab-pane">
            <div class="inventory-parent"></div>
        </div> -->
    </div>
</div>
